import { Options } from "@components/modules/Table/types"
import { route } from "@helpers"
import useAuth from "@hooks/useAuth"
import useStatic from "@hooks/useStatic"
import { useHistory } from "react-router"

export default function useClubsTableOptions() {
    const history = useHistory()
    const auth = useAuth()

    const loginToClub = async (userId: string | number) => {
        await auth.loginAsUser(userId)
        history.push(route("club:customer"))
    }

    return useStatic<Options<Club.Admin.Resources.Club>>({
        actions: [
            { label: "Visit", action: row => loginToClub(row.original.owner.id) }
        ]
    })
}